/* dev-site-header.js */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

function initAll() {
  document.querySelectorAll('.site-header').forEach(section => init(section));
  openCartDrawerAfterRedirect();
}

function init(section) {
  initHamburger(section);
  initScrollShadow(section);
  initCartDrawerTriggers(section);
}

// The cart page redirects back here (see snippets/dev-cart-page-redirect.liquid)
// and leaves a flag behind, so the shopper lands on the drawer instead of the
// stock cart template. The drawer script is loaded lazily, hence whenDefined.
function openCartDrawerAfterRedirect() {
  let flagged = null;

  try {
    flagged = sessionStorage.getItem('dev-open-cart-drawer');
    if (flagged) sessionStorage.removeItem('dev-open-cart-drawer');
  } catch (error) {
    return;
  }

  if (!flagged) return;

  customElements.whenDefined('cart-drawer-component').then(() => {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) drawer.open();
  });
}

function initCartDrawerTriggers(section) {
  section.addEventListener('click', (e) => {
    if (!e.target.closest('[data-open-cart-drawer]')) return;

    const drawer = document.querySelector('cart-drawer-component');

    if (drawer) {
      drawer.open();
      return;
    }

    // The drawer is not rendered on the cart template (its markup would clash
    // with the stock cart form), so fall back to the cart route rather than
    // leaving the button dead.
    const cartUrl = (typeof Theme !== 'undefined' && Theme?.routes?.cart_url) || '/cart';
    window.location.href = cartUrl;
  });
}

function initHamburger(section) {
  const hamburger = section.querySelector('[data-hamburger]');
  const menu = section.querySelector('[data-mobile-menu]');
  const backdrop = section.querySelector('[data-menu-backdrop]');

  if (!hamburger || !menu) return;

  // Distance from viewport top where the floating panel + blur should start
  // (just below the announcement / shipping bar). Measured at open time.
  function computeMenuTop() {
    const bar = document.querySelector('.shipping-info-bar-wrapper');
    if (bar) {
      const bottom = bar.getBoundingClientRect().bottom;
      if (bottom > 0 && bottom < window.innerHeight * 0.5) return Math.round(bottom);
    }
    return Math.max(0, Math.round(section.getBoundingClientRect().top));
  }

  function openMenu() {
    section.style.setProperty('--menu-top', computeMenuTop() + 'px');
    hamburger.setAttribute('aria-expanded', 'true');
    section.classList.add('site-header--menu-open');
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('site-header-menu-open');
    menu.querySelectorAll('[tabindex="-1"]').forEach(el => el.removeAttribute('tabindex'));
  }

  function closeMenu() {
    if (!section.classList.contains('site-header--menu-open')) return;
    hamburger.setAttribute('aria-expanded', 'false');
    section.classList.remove('site-header--menu-open');
    menu.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('site-header-menu-open');
    menu.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', '-1'));
  }

  hamburger.addEventListener('click', () => {
    const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
    isOpen ? closeMenu() : openMenu();
  });

  // Close when a navigation link is followed
  menu.addEventListener('click', (e) => {
    if (e.target.closest('a')) closeMenu();
  });

  // Close when tapping the blurred backdrop
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
}

function initScrollShadow(section) {
  const inner = section.querySelector('.site-header__inner');
  if (!inner) return;

  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
  document.body.prepend(sentinel);

  const observer = new IntersectionObserver(
    ([entry]) => {
      inner.classList.toggle('site-header__inner--scrolled', !entry.isIntersecting);
    },
    { threshold: 1 }
  );

  observer.observe(sentinel);
}
